import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { TokenService } from '../services/tokenService';
import { Button } from './ui/button';

const TokenCountdownTimer: React.FC = () => {
  const { tokenUser, getRemainingTime, logout } = useAuth();
  const [displayTime, setDisplayTime] = useState<string>('00:00');
  const [isWarning, setIsWarning] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!tokenUser) return;

    const updateTimer = () => {
      const remaining = getRemainingTime();
      if (!remaining) return;

      if (remaining.isExpired) {
        logout();
        navigate('/login');
        return;
      }

      const formattedTime = TokenService.formatRemainingTime(
        remaining.hours,
        remaining.minutes
      );
      setDisplayTime(formattedTime);
      setIsWarning(remaining.hours === 0);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000);

    return () => clearInterval(interval);
  }, [tokenUser, getRemainingTime, logout, navigate]);

  if (!tokenUser) return null;

  return (
    <div
      className={`fixed top-4 right-4 flex items-center gap-3 px-4 py-2 rounded-lg border ${
        isWarning
          ? 'bg-orange-50 border-orange-200'
          : 'bg-blue-50 border-blue-200'
      }`}
    >
      <div className="flex flex-col items-end">
        <span className={`text-sm font-semibold ${
          isWarning ? 'text-orange-700' : 'text-blue-700'
        }`}>
          {displayTime}
        </span>
        <span className={`text-xs ${
          isWarning ? 'text-orange-600' : 'text-blue-600'
        }`}>
          remaining
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          logout();
          navigate('/login');
        }}
        className={`text-xs ${
          isWarning
            ? 'text-orange-700 hover:bg-orange-100'
            : 'text-blue-700 hover:bg-blue-100'
        }`}
      >
        Logout
      </Button>
    </div>
  );
};

export default TokenCountdownTimer;
